import {AiFillStar} from 'react-icons/ai'
import {MdLocationOn} from 'react-icons/md'
import {FaToolbox} from 'react-icons/fa'
import './index.css'

const SimilarJobs = props => {
  const {similarJob} = props
  const {
    companyLogoUrl,
    employmentType,
    jobDescription,
    location,
    rating,
    title,
  } = similarJob
  return (
    <li className="jobs-list-item">
      <div className="top-container">
        <img
          className="company-logo"
          src={companyLogoUrl}
          alt="similar job company logo"
        />
        <div className="title-card">
          <h1 className="title">{title}</h1>
          <div className="rating-card">
            <AiFillStar color="#fbbf24" height="20" width="20" />
            <p className="rating">{rating}</p>
          </div>
        </div>
      </div>
      <p className="description">Description</p>
      <p className="job-description">{jobDescription}</p>
      <div className="middle-card">
        <MdLocationOn color="#ffffff" height="20" width="20" />
        <p className="location">{location}</p>
        <FaToolbox color="#ffffff" height="20" width="20" />
        <p className="type-of-employment">{employmentType}</p>
      </div>
    </li>
  )
}

export default SimilarJobs
